import React from "react";
import { DateUtility } from "../../utils/dateUtility";

const MatchDateTime = ({ match, sport = "football", difference }) => {
  return (
    <>
      <span
        className={`${sport === "basketball" || sport === "tennis" || sport === "cricket" || sport === 'icehockey'
          ? "time"
          : "status"
          }`}
      >
        {difference
          ? DateUtility?.ConvertCETtoCurrentTimeZone(
            match?.dt || match?.gdt,
            difference
          )
          : DateUtility?.FormatTime(match?.dt || match?.gdt)}
      </span>
    </>
  );
};

export default MatchDateTime;
